import {
  Container,
  ContentLayout,
  ExpandableSection,
  Grid,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import {
  HEAT_PID_FIELDS_BY_SIDE,
  HEAT_ZONE_CONFIG_FIELDS_BY_SIDE,
} from 'features/plc/contracts/pressHMI.fields';
import {
  BONDING_CYCLE_STATE_LABELS,
  PLC_PATHS,
} from 'features/plc/contracts/pressHMI.schema';
import React from 'react';

import HeatBlockStatus from '../components/heatBlockStatus';
import HeaterThermalStatus from '../components/heaterThermalStatus';
import HeatZoneConfig from '../components/heatZoneConfig';
import OverrideControls from '../components/overrideControls';
import PIDControls from '../components/pidControls';
import PressHMIHeader from '../components/pressHMIHeader';
import SystemStatusAndControl from '../components/systemStatusAndControl';
import AutomationControls from './automationControls';

export default function BondingContent() {
  return (
    <ContentLayout header={(
      <PressHMIHeader
        cycleStatePath={PLC_PATHS.status.bondingCycleState}
        cycleStateLabels={BONDING_CYCLE_STATE_LABELS}
        disableLabel="Disable bonding mode"
      />
    )}
    >
      <SpaceBetween direction="vertical" size="xl">
        <AutomationControls />
        <Grid
          gridDefinition={[
            { colspan: 6 }, { colspan: 6 },
          ]}
        >
          <HeaterThermalStatus />
          <SystemStatusAndControl />
        </Grid>
        <Container header={<Header>Additional settings</Header>}>
          <SpaceBetween direction="vertical" size="xl">
            <ExpandableSection headerText="Override controls">
              <OverrideControls />
            </ExpandableSection>
            <ExpandableSection headerText="Heat PID controls">
              <PIDControls
                fieldsBySide={HEAT_PID_FIELDS_BY_SIDE}
                upperTitle="Upper Heat PID"
                lowerTitle="Lower Heat PID"
              />
            </ExpandableSection>
            <ExpandableSection headerText="Upper Heat Zone Config">
              <HeatZoneConfig fieldsBySide={HEAT_ZONE_CONFIG_FIELDS_BY_SIDE.upper} />
            </ExpandableSection>
            <ExpandableSection headerText="Lower Heat Zone Config">
              <HeatZoneConfig fieldsBySide={HEAT_ZONE_CONFIG_FIELDS_BY_SIDE.lower} />
            </ExpandableSection>
            <ExpandableSection headerText="Heat block status">
              <HeatBlockStatus />
            </ExpandableSection>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    </ContentLayout>
  );
}
